/**
 * Created by rak on 4/28/2015.
 */

'use strict';
angular.module('dashboard.vehicleDetails', ['adf.provider'])
  .config(function (dashboardProvider) {
    dashboardProvider
      .widget('vehicleDetailsWidget', {
        resolve: {
          title: function () {
            return 'dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle';
          },
          description: function () {
            return 'dashBoard.fleetManagement.vehicleDetails.description';
          }
        },
        controller: 'vehicleDetailCtrl',
        templateUrl: 'components/dashboard/vehicleDetails/vehicleDetailWidget.tpl.html',
        isSingleInstance: true,
        reload: true,
        config: {
          selectedRowDetails: {
            deviceId: null,
            startDate: null,
            endDate: null
          },
          noOfGridRows: 10
        },
        edit: {
          templateUrl: 'components/dashboard/vehicleDetails/vehicleDetailEdit.tpl.html',
          reload: false,
          controller: 'vehicleDetailEditCtrl'
        }
      });
  }).service('vehicleDetailWidgetService', function (crudService) {
    this.getVehicleEvntDetailList = function (deviceId, isDataRefresh, startDate, endDate) {
      var requestParam = {
        statusCode: '',
        vehicleGroup: '',
        dataRefresh: isDataRefresh,
        timeTo: endDate,
        timeFrom: startDate,
        reportName: 'EventDetailAll'
      };
      var param = {
        'filter': JSON.stringify(requestParam)
      };
      return crudService.customGET('overview', 'vehicleeventdetailall/' + deviceId, param);
    };

    this.getVehicleEvntDetailViewSettingsList = function(deviceId, isDataRefresh, startDate, endDate) {
      var requestParam = {
        statusCode: '',
        vehicleGroup: '',
        dataRefresh: isDataRefresh,
        timeTo: endDate,
        timeFrom: startDate,
        reportName: 'EventDetailAll'
      };
      var param = {
        'filter': JSON.stringify(requestParam)
      };
      return crudService.customGET('viewsettings/dataset', 'eventdetailall', param);
    };

  }).controller('vehicleDetailCtrl', function ($scope, $rootScope, vehicleDetailWidgetService, config, localStorageService, commonTrackService, $translate, $filter, errorHandlingService, vehicleListWidgetService, stateManagerService, $timeout, AuthenticationService) {
    $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
    $scope.dataLoadingFinished = false;

    $scope.isNotAuthorized = false;
    $scope.isDataNotAvailable = false;
    $scope.isWidgetPreInitFinished = false; // Pre ini animation automatically removed if anoy one of above two flags set to true
    $scope.isWidgetPostInitFinished = false;

    var rowSize = vehicleListWidgetService.getRowSize();
    var allData;

    // Test bug
    // Required params
    $scope.dataSet = {
      deviceID: null,
      startDate: null,
      endDate: null,
      refresh: null,
      lastUpdateRequest: 0
    };

    var _tmpColumnProperties = [{
      name: 'name', width: '50%',
      hasIcon: true,
      type: 'string'
    }, {
      name: 'value', width: '50%',
      type: 'string'
    }];

    $scope.customGridProperties = {
      settings: {
        vehicleDetails: {
          autoheight: false,
          height: config.noOfGridRows ? rowSize[config.noOfGridRows] - 15 : 455,
          pageable: false,
          pagesize: null,
          showfilterrow: true,
          filterable: true,
          columns: []
        },
        customcolumnproperties: []
      }
    };
    var columnProperties = commonTrackService.getColumnProperties(_tmpColumnProperties, {
      name: $translate.instant('dashBoard.fleetManagement.vehicleDetails.name'),
      value: $translate.instant('dashBoard.fleetManagement.vehicleDetails.value')
    }, { moduleName: 'vehicleDetailsWidget' });

    var vehicleDetailsListSource =
    {
      datatype: 'array',
      datafields: [],
      localdata: [],
      unfiltereddata: []
    };

    $scope.customGridProperties.settings.vehicleDetails.columns = columnProperties;
    var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle') };
    $scope.vehicleDetialsWidgGridSettings = commonTrackService.getGridSettings('vehicleDetailsWidget', $scope.customGridProperties.settings.vehicleDetails, null, _additionalProperties);
    $scope.vehicleDetailListdataAdapter = new window.$.jqx.dataAdapter(vehicleDetailsListSource);
    $scope.vehicleDetialsWidgGridSettings.source = $scope.vehicleDetailListdataAdapter;


    $scope.updateFilter = function(buttonID) {
      var checkedItems = [];
      var selectedButtons = [];

      if(localStorageService.get('selectedEventDetailsButtons') !== null) {
        selectedButtons = localStorageService.get('selectedEventDetailsButtons');
      }

      //restore filters that were previously saved to local storage
      //done on refresh etc
      for(var x= selectedButtons.length-1; x >= 0; x--) {
        if(getDataSetListItem(selectedButtons[x]) === undefined) {
          //remove this invalid selected button from list of selected buttons
          selectedButtons.splice(x, 1);
          continue;
        }

        var arrayOfDataSetTagsForLocalStorage = getAllRowsMatchingDataSetTags(selectedButtons[x]);
        checkedItems.push.apply(checkedItems, arrayOfDataSetTagsForLocalStorage);
      }

      if(buttonID !== undefined) {
        //manage filters for when a button is clicked
        var arrayOfDataSetTagsForbuttonID = getAllRowsMatchingDataSetTags(buttonID);

        if(selectedButtons.includes(buttonID)) {
          //Remove the button items
          var index = selectedButtons.indexOf(buttonID);
          selectedButtons.splice(index, 1);

          for(var y=0; y<arrayOfDataSetTagsForbuttonID.length; y++){
            var indexOfItemToRemove = checkedItems.lastIndexOf(arrayOfDataSetTagsForbuttonID[y]);
            if (index > -1) {
              checkedItems.splice(indexOfItemToRemove, 1);
            }
          }
        } else {
          //Add the button items
          selectedButtons.push(buttonID);
          checkedItems.push.apply(checkedItems, arrayOfDataSetTagsForbuttonID);
        }
      }
      localStorageService.set('selectedEventDetailsButtons', selectedButtons);

      filterFunction(checkedItems);
    };

    var getDataSetListItem = function(itemID) {
      var dataSetListItem = allData.dataSetList.find(function(item) {
        return item.id===itemID;
      });
      return dataSetListItem;
    };

    var getAllRowsMatchingDataSetTags = function(itemID) {
      var arrayOfDataSetTagsColumns = [];
      var dataSetListItem = getDataSetListItem(itemID);
      if(dataSetListItem !== undefined) {
        for(var x=0; x< dataSetListItem.tags.length; x++) {
          //get the filter columns
          var tagsName = dataSetListItem.tags[x].name.toLowerCase();
          var checkedItem = $scope.customGridProperties.settings.columnTranslation[tagsName];
          if(checkedItem !== undefined && checkedItem !== '') {
            arrayOfDataSetTagsColumns.push(checkedItem.replace(/\\n/gm, ' - '));
          }
        }
      }
      return arrayOfDataSetTagsColumns;
    };

    var getAllDataSetTagsObjects = function() {
      var allTagsObjects = [];
        for(var a = 0; a < allData.dataSetList.length; a ++) {
          var allDataSetListItem = allData.dataSetList[a];
          for(var b = 0; b < allDataSetListItem.tags.length; b++) {
            var tagsItem = allDataSetListItem.tags[b];
            if(tagsItem.iconRulesRef !== undefined && tagsItem.iconRulesRef !== '') {
              // this is a tags item with icon
              allTagsObjects.push(tagsItem);
            }
          }
        }
        return allTagsObjects;
    };

    var loadVehicleEventDetail = function (deviceId, dataRefresh, startDate, endDate) {

      $scope.isNotAuthorized = false;  // Reset if its already set to true so that if permissions enabled on fly 'UI no autorized message will be removed'
      $scope.isDataNotAvailable = false;

      vehicleDetailWidgetService.getVehicleEvntDetailViewSettingsList(deviceId, dataRefresh, startDate, endDate).then(function (viewSettingsData) {
        allData = viewSettingsData;

        return vehicleDetailWidgetService.getVehicleEvntDetailList(deviceId, dataRefresh, startDate, endDate).then(function (vehicleEvntDetail) {
          var allTagsObjects = getAllDataSetTagsObjects();

          var _tmpDetail = [];
          if ($scope.customGridProperties.settings.customcolumnproperties.length === 0) {
            $scope.customGridProperties.settings.customcolumnproperties = vehicleEvntDetail.gridSettings.overviewListGrids[0].columnProperties;
            $scope.customGridProperties.settings.columnTranslation = vehicleEvntDetail.columnTranslation;
          }
          var findColumnPropertiesItem = function(item) {
            return item.name.toLowerCase()===columnPropertiesItem.name;
          };
          for (var i = 0; i < $scope.customGridProperties.settings.customcolumnproperties.length; i++) {
            var columnPropertiesItem = $scope.customGridProperties.settings.customcolumnproperties[i];
            var tagsObject = allTagsObjects.find(findColumnPropertiesItem);

            if (vehicleEvntDetail.dataList.length === 1) {
              var name = $scope.customGridProperties.settings.customcolumnproperties[i].name;
              var type = $scope.customGridProperties.settings.customcolumnproperties[i].type;
              var value = vehicleEvntDetail.dataList[0][name] ? vehicleEvntDetail.dataList[0][name] : null;
              if (typeof vehicleEvntDetail.dataList[0][name] === 'number' && type !== 'TIMESTAMP') {
                if (value) {
                  if (value._isInt(value)) {
                    /*if (name.indexOf('timestamp') > -1) {
                     value = $filter('date')(new Date(value), 'dd/MM/yyyy HH:mm:ss');
                     } else {
                     value = String(value);
                     }*/
                    value = String(value);
                  } else {
                    if (value._isFloat(value)) {
                      value = String(value.toFixed(4));
                    }
                  }
                }

              }
              if (type === 'TIMESTAMP' && value) {
                value = $filter('date')(new Date(value * 1000), 'dd/MM/yyyy HH:mm:ss');
              }
              //add column icons using icon rules
              var nameIcon = evaluateIconRule(columnPropertiesItem, value, tagsObject, nameIcon);
              if ($scope.customGridProperties.settings.columnTranslation[name]) {
                var _detailObjFormat = {
                  name: $scope.customGridProperties.settings.columnTranslation[name].replace(/\\n/gm, ' - '),
                  value: value,
                  nameIcon: nameIcon,
                  nameIconDisplayType: 'COMBINATION'
                };
                _tmpDetail.push(_detailObjFormat);
              }
            }
          }

          vehicleDetailsListSource.localdata = _tmpDetail;
          vehicleDetailsListSource.unfiltereddata = _tmpDetail;
          $scope.isDataNotAvailable = _tmpDetail.length > 0 ? false : true;
          commonTrackService.updateBoundData($scope.overviewGridPrefix + 'vehicleDetailsWidgetList');

          //add all nessisary buttons to screen
          var buttonsArray = [];
          var selectedButtons = [];
          if(localStorageService.get('selectedEventDetailsButtons') !== null) {
            selectedButtons = localStorageService.get('selectedEventDetailsButtons');
          }
          for(var x =0; x < allData.dataSetList.length; x++) {
            var buttonName = allData.dataSetList[x].name;
            var buttonID = allData.dataSetList[x].id;
            var isStoredLocally = selectedButtons.includes(buttonID) ? 'active' : '';
            buttonsArray.push({ _buttonName: buttonName,  _buttonID: buttonID, _isActive: isStoredLocally});
          }
          $scope.buttonsArray = buttonsArray;


        }, function (response) {
          $scope.isDataNotAvailable = true;
          if (errorHandlingService.errorForNoAuthorized(response)) {
            $scope.isNotAuthorized = true;

          }
        }).finally(function () {
          $scope.dataLoadingFinished = true;
          $scope.updateFilter();
        });
      }, function (response) {
        $scope.isDataNotAvailable = true;
        if (errorHandlingService.errorForNoAuthorized(response)) {
          $scope.isNotAuthorized = true;
        }
      });
    };

    var filterFunction = function(checkedItems) {
      //Update the grid data with the filtered items
      $timeout(function () {
        var filteredItems = [];
        var findCheckedItemFunction = function(item) {
          return item.name===checkedItems[i];
        };
        for (var i = 0; i < checkedItems.length; i++) {
          // add checked values to the filter
          var filteredItem = vehicleDetailsListSource.unfiltereddata.find(findCheckedItemFunction);
          if(filteredItem !== undefined && !filteredItems.includes(filteredItem)) {
            filteredItems.push(filteredItem);
          }
        }
        // add the filters.
        if(filteredItems.length === 0) {
          vehicleDetailsListSource.localdata = vehicleDetailsListSource.unfiltereddata;
        } else {
          vehicleDetailsListSource.localdata = filteredItems;
        }
        commonTrackService.updateBoundData($scope.overviewGridPrefix + 'vehicleDetailsWidgetList');
      }, 0);
    };

    var evaluateIconRule = function(columnPropertiesItem, value, tagsObject) {
      var nameIcon = 'NONE';
      if(tagsObject !== undefined) {
        //this column contains an icon
        columnPropertiesItem.hasIcon = true;
        //calculate which icon should be displayed
        var iconRule = allData.iconRules.find(function(item) {
          return item.name===tagsObject.iconRulesRef;
        });
        if(iconRule !== undefined) {
          if(iconRule.enumValue !== undefined) {
            //icon rule is of type enum
            //evaluate enum
            var enumValue = iconRule.enumValue;
            var enumIcon = iconRule.enumIcon;

            for(var x=0; x<enumValue.length; x++) {
              if(enumValue[x] === value) {
                nameIcon = enumIcon[x];
              }
            }
          } else if(iconRule.conditions !== undefined) {
            //icon rule is of type conditions
            //evaluate conditions
            for(var y=0; y < iconRule.conditions.length; y++) {
              var operator = iconRule.conditions[y].operator;

              var icon = iconRule.conditions[y].icon;
              var comparatorNumber = parseFloat(value);

              if(isNaN(comparatorNumber)) {
                var thresholdString = iconRule.conditions[y].threshold;
                switch(operator) {
                  case 'equals':
                    if(value === thresholdString) {
                      nameIcon = icon;
                    }
                    break;
                }
              } else {
                var thresholdNumber = parseFloat(iconRule.conditions[y].threshold);
                switch(operator) {
                  case 'equals':
                    if(comparatorNumber === thresholdNumber) {
                      nameIcon = icon;
                    }
                    break;
                  case 'lower_than':
                    if(comparatorNumber < thresholdNumber) {
                      nameIcon = icon;
                    }
                    break;
                  case 'lower_or_equal':
                    if(comparatorNumber <= thresholdNumber) {
                      nameIcon = icon;
                    }
                    break;
                  case 'greater_or_equal':
                    if(comparatorNumber >= thresholdNumber) {
                      nameIcon = icon;
                    }
                    break;
                  case 'greater_than':
                    if(comparatorNumber > thresholdNumber) {
                      nameIcon = icon;
                    }
                    break;
                }
              }
            }
          }
        }
      }
      return nameIcon;
    };

    // Test bug
    $scope.$on('dataStateUpdate', function (event, data) {
      if ($scope.isWidgetPostInitFinished) {
        var set = getSetData(data.widget);
        _handleDataUpdate(data.dashboardName, data.activeTab, set['tab_' + data.activeTab + '_selectedRow'].value);
      } else {
        console.log('Ignoring dataState update from widget: ' + data.widget);
      }

    });


    var maxGetInitialDataRetries = 30;
    var currentParentRowResEvent = $scope.$on('resDataUpdate', function (event, data) {
      if (maxGetInitialDataRetries < 0 || $scope.isWidgetPostInitFinished) {
        currentParentRowResEvent();
        return;
      }
      //console.info('VehcielDetail Widget Requesting Parent for Data ..');
      --maxGetInitialDataRetries;
      var set = getSetData(data.widget);
      var selectedParentTabRowValues = set['tab_' + data.activeTab + '_selectedRow'];


      // parents First tab must always retrun a  valid selected row
      if ((data.activeTab === 0 && !_.isEmpty(selectedParentTabRowValues) && !_.isEmpty(selectedParentTabRowValues.value)) || (data.activeTab > 0 && !_.isEmpty(selectedParentTabRowValues))) {
        $scope.isWidgetPreInitFinished = true;
        $scope.isWidgetPostInitFinished = true;
        _handleDataUpdate(data.dashboardName, data.activeTab, selectedParentTabRowValues.value);

      } else {
        // Repeatedly try to get the data from parent .
        if (maxGetInitialDataRetries > 0) {
          $timeout(function () {
            if (!$scope.isWidgetPostInitFinished) {
              $rootScope.$broadcast('reqDataUpdate');
            }
          }, 100);
        } else {
          console.warn('Max Retries exceeded to get the current Parent data for VehcielDetail widget..');
          $scope.isWidgetPreInitFinished = true;
          $scope.isWidgetPostInitFinished = true;
          $scope.isDataNotAvailable = true;
          currentParentRowResEvent();
        }
      }

    });

    $scope.$on('$destroy', function () {
      delete $scope.vehicleDetailListdataAdapter;
      delete $scope.vehicleDetialsWidgGridSettings.source;
      currentParentRowResEvent();
    });

    var getSetData = function (widget) {
      var loginID = AuthenticationService.GetLoginID();
      widget = loginID.Account+'_'+loginID.username +'_'+widget;
      var stateData = stateManagerService.getStateData();
      var set = stateData && stateData[widget] ? stateData[widget] : {};
      return set;
    };

    this.init = function () {
      $timeout(function () {
        $scope.dataSet.lastUpdateRequest = new Date().getTime();
        $rootScope.$broadcast('reqDataUpdate');
      }, 0);

    };

    function _handleDataUpdate(dashboardName, tabNumber, rowData) {
      var reportDatetime, set;

      switch (dashboardName) {
        case 'dashboard.vehicleList':
        case 'dashboard.driverWrkHrsDashboard': // contains only 0 tab
        case 'dashboard.tachohistory':// contains only 0 tab

          switch (tabNumber) {
            case 1:
              set = getSetData('vehicleListWidget'); // hard coded  values since other dashboard does not contain tab 1
              if (!_.isEmpty(set['tab_' + 0 + '_selectedRow'])) {
                rowData = set['tab_' + 0 + '_selectedRow'].value;
                reportDatetime = commonTrackService.formatReportDateTime(rowData.date, rowData.time);
                loadVehicleEventDetail(rowData.deviceid, $scope.customGridProperties.settings.customcolumnproperties.length > 0 ? false : true, reportDatetime, reportDatetime);
              }
              break;
            case 0:
            case 2:
            case 3:
              reportDatetime = commonTrackService.formatReportDateTime(rowData.date, rowData.time);
              loadVehicleEventDetail(rowData.deviceid, $scope.customGridProperties.settings.customcolumnproperties.length > 0 ? false : true, reportDatetime, reportDatetime);
              break;
          }
          break;
        case 'dashboard.fmsDashboard':


          switch (tabNumber) {
            case 0:
            case 1:
              reportDatetime = commonTrackService.formatReportDateTime(rowData.date, rowData.time);
              loadVehicleEventDetail(rowData.deviceid, $scope.customGridProperties.settings.customcolumnproperties.length > 0 ? false : true, reportDatetime, reportDatetime);
              break;
            case 2:
              set = getSetData('fmsVehicleWidget');
              if (!_.isEmpty(set['tab_' + 0 + '_selectedRow'])) {
                rowData = set['tab_' + 0 + '_selectedRow'].value;
                var tellTaletimestamp = rowData.telltaletimestamp;
                var hastellTale = tellTaletimestamp > 0;
                if (hastellTale) {
                  var tellTaledate = (hastellTale ? moment.unix($scope.telltaleData.timestamp) : moment(0)).format('YYYY/MM/DD/HH:mm:ss');

                  loadVehicleEventDetail(rowData.deviceid, $scope.customGridProperties.settings.customcolumnproperties.length > 0 ? false : true, tellTaledate, tellTaledate);

                } else {
                  $scope.isDataNotAvailable = true;
                }
              }
              break;

          }
          break;
        case 'dashboard.tachoDownloadStatusList':
          set = getSetData('tachoDownloadStatusWidget'); // hard coded  values since other dashboard does not contain tab 1
          if (!_.isEmpty(set['tab_' + 0 + '_selectedRow'])) {
            rowData = set['tab_' + 0 + '_selectedRow'].value;
            if(rowData.tacholasteventtimestamp && (rowData.tacholasteventtimestamp !== '')){
              reportDatetime = moment(rowData.tacholasteventtimestamp*1000).format('YYYY/MM/DD/HH:mm:ss');
              loadVehicleEventDetail(rowData.deviceid, $scope.customGridProperties.settings.customcolumnproperties.length > 0 ? false : true, reportDatetime, reportDatetime);
            } else {
              $scope.isDataNotAvailable = true;
            }
          }
          break;

      }
    }
    this.init();

  }).controller('vehicleDetailEditCtrl', function ($scope, config, $translate, widgetSettingsCreatorService) {
    $scope.noOfGridRows = config.noOfGridRows;
    var source = [
      '5', '10', '15', '25'
    ];

    // init DropDownList's settings object.
    $scope.noOfRowsettings =
    {
      placeHolder: $translate.instant('dashBoard.fleetManagement.vehicleList.noOfGridRows'),
      width: 200, height: 25,
      autoDropDownHeight: true,
      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, //'material', // theme: 'bootstrap',
      source: source
    };

    $scope.noOfGridOnChange = function (event) {
      config.noOfGridRows = event.args.item.value;
    };
  });



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/vehicleDetails/vehicleDetailWidget.js